import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ProductEvaluationTaskService } from '../../../services/product-evaluation-task.service';
import { Subscription } from 'rxjs';
import { ProductEvaluationSurveyResult } from '../../../models/product-evaluation-tasks/ProductEvaluationSurveyResult';
import { CriteriaAnswerTypeCode } from '../../../models/product-evaluation-tasks/enums/CriteriaAnswerTypeCodeEnum';

@Component({
  selector: 'app-product-evaluation-result',
  standalone: false,
  templateUrl: './product-evaluation-result.component.html'
})
export class ProductEvaluationResultComponent implements OnInit, OnDestroy {
  @Input() selectedRecordId!: number;
  @Input() taskId!: number;
  dataLoading = false;
  @Output() close = new EventEmitter<boolean>();
  subscriptions: Subscription[] = [];
  details: ProductEvaluationSurveyResult = new ProductEvaluationSurveyResult();
  criteriaAnswerTypeCode = CriteriaAnswerTypeCode

  constructor(
    private service: ProductEvaluationTaskService,
  ) { }

  ngOnInit(): void {
    this.getDetails();
    this.subscriptions.push(
      this.service.closeDetails.subscribe(data => {
        if (data) {
          this.close.emit();
          this.service.closeDetails.next(false);
        }
      })
    )
    this.subscriptions.push(
      this.service.refreshDetails.subscribe(data => {
        if (data) {
          this.getDetails();
        }
      })
    )
  }

  getDetails() {
    this.dataLoading = true;
    let params = {
      taskId:this.taskId,
      productId:this.selectedRecordId
    }
    this.service.getProductEvaluationSurveyResult(params).subscribe((data: any) => {
      this.dataLoading = false;
      this.details = data;
    })
  }

  ngOnDestroy(): void {
    this.service.closeDetails.next(false);
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
